module.exports = __webpack_public_path__ + "static/media/70.17bee404.jpg";